const base = require('base/login/login');
const createErrorNotification = require('base/components/errorNotification');
const formValidation = require('../components/formValidation');
const loader = require('../components/loader');
const clientSideValidation = require('../components/clientSideValidation');
const getAnalyticsEventBus = require('../common/getAnalyticsEventBus');
const { showElementsBySelector } = require('../common/utils/dom');
const { initializeCheckoutLogin } = require('../checkout/checkoutLogin');

const analyticsEventBus = getAnalyticsEventBus();
const { FRONT_CONFIG } = window;
const requestPasswordResetModalName = '#requestPasswordResetModal';
const requestPasswordResetModalClass = 'request-password-reset-card';
const titlePasswordResetClass = `.${requestPasswordResetModalClass} .card-header__title`;
const subtitlePasswordResetClass = `.${requestPasswordResetModalClass} .card-header__subtitle`;
const submitLoginClass = 'login__submit';
const backToLoginClass = '.back-to-login';
const backToLoginLinkClass = '.back-to-login__link';
const submitLoginHiddenClass = `${submitLoginClass}--hidden`;
const textTitlePasswordReset = $(titlePasswordResetClass).text();
const textSubTitlePasswordReset = $(subtitlePasswordResetClass).text();

const toggleLoginSubmit = () => {
  const requestPasswordResetModal = document.querySelector(
    requestPasswordResetModalName
  );
  if (!requestPasswordResetModal) return;
  const loginSubmit = document.querySelector(`.${submitLoginClass}`);
  if (!loginSubmit) return;
  $(requestPasswordResetModal).on('show.bs.collapse', () => {
    loginSubmit.classList.add(submitLoginHiddenClass);
    const heightButtonLogin = loginSubmit.offsetHeight;
    requestPasswordResetModal.style.setProperty(
      'top',
      `-${heightButtonLogin}px`
    );

    setTimeout(() => {
      clientSideValidation.handleSubmitState($('.reset-password.form')[0]);
    }, 100);
  });
  $(requestPasswordResetModal).on('hide.bs.collapse', () => {
    // delay event by modal transition
    setTimeout(() => {
      loginSubmit.classList.remove(submitLoginHiddenClass);
      $(titlePasswordResetClass).text(textTitlePasswordReset);
      $(subtitlePasswordResetClass).text(textSubTitlePasswordReset);
      $(requestPasswordResetModalName).removeClass(
        `${requestPasswordResetModalClass}--sent`
      );
    }, 300);
  });
};

function showBackToLogin() {
  showElementsBySelector(backToLoginClass);
  const backToLoginLink = document.querySelector(backToLoginLinkClass);
  // eslint-disable-next-line listeners/no-missing-remove-event-listener
  backToLoginLink.addEventListener('click', initializeCheckoutLogin);
}

function changePasswordModalText(data, hideModal) {
  $(titlePasswordResetClass).text(data.receivedMsgHeading);
  $(subtitlePasswordResetClass).text(data.receivedMsgBody);
  $(requestPasswordResetModalName).addClass(
    `${requestPasswordResetModalClass}--sent`
  );
  if (hideModal) {
    setTimeout(() => {
      $(requestPasswordResetModalName).collapse('hide');
    }, 4000);
  } else {
    showBackToLogin();
  }
}

function validateLoginBusinessData() {
  // Form business logic validation
  return true;
}

function isCartRecovery() {
  const urlParams = new URLSearchParams(window.location.search);
  const referrerParamValue = urlParams.get('referrer');
  return referrerParamValue === 'cartRecovery';
}

function isVentaPrivada() {
  const urlParams = new URLSearchParams(window.location.search);
  const actionParamValue = urlParams.get('action');
  if (actionParamValue === 'vp' && FRONT_CONFIG.ventaPrivadaCategoryID) {
    return true;
  }
  return false;
}

function ventaPrivadaRedirect() {
  return `${FRONT_CONFIG.urls.searchShow}?cgid=${FRONT_CONFIG.ventaPrivadaCategoryID}`;
}

function submitLogin($form) {
  const url = $form.attr('action');
  const submitButton = document.querySelector(`.${submitLoginClass}`);
  const isCheckoutLoginPage =
    window.location.pathname === FRONT_CONFIG.urls.checkout;
  if (!isCheckoutLoginPage) {
    loader.addLoader(submitButton);
  }
  $form.trigger('login:submit');
  $.ajax({
    url,
    type: 'post',
    dataType: 'json',
    data: $form.serialize(),
    success(data) {
      if (!data.success) {
        if (!isCheckoutLoginPage) {
          loader.removeLoader(submitButton);
        }
        formValidation($form, data);
        $form.trigger('login:error', data);
      } else {
        $form.trigger('login:success', data);
        $('body').trigger('customer:login', data.customerID);
        let redirectUrl;
        if (isCheckoutLoginPage) {
          // Send info for Analytics
          gaInfo.checkoutOptions.userAccess = 'email';
          analyticsEventBus.publish(
            analyticsEventBus.EVENTS.checkoutProcessStarted,
            {
              order: data.order,
            }
          );
          let dlStepParameter = data.redirectUrl.includes('?') ? '&' : '?';
          dlStepParameter += 'dlStep=2';
          redirectUrl = data.redirectUrl + dlStepParameter;
        } else {
          redirectUrl = isVentaPrivada()
            ? ventaPrivadaRedirect()
            : data.redirectUrl;
        }
        if (isCartRecovery()) {
          // Send info for analytics
          analyticsEventBus.publish(
            analyticsEventBus.EVENTS.modalCartRecoveryLogged,
            {
              detail: { referrer: 'cartRecovery' },
            }
          );
        }
        window.location.href = redirectUrl;
      }
    },
    error(data) {
      if (data.responseJSON && data.responseJSON.redirectUrl) {
        window.location.href = data.responseJSON.redirectUrl;
      } else {
        $form.trigger('login:error', data);
        if (!isCheckoutLoginPage) {
          loader.removeLoader(submitButton);
        }
      }
    },
  });
}

function checksLoginBeforeSubmit(e) {
  const $form = $(e.target);
  const form = $form[0]; // jq to element
  e.preventDefault();

  const isFormatValid = clientSideValidation.functions.validateFormatData(form);
  if (isFormatValid) {
    const isBusinessValid = validateLoginBusinessData(form);

    if (isBusinessValid) {
      submitLogin($form);
    }
  }
}

function validateRegisterBusinessData(form) {
  // Form business logic validation
  let isValid = true;

  // both passwords are equal validation
  const passwordField = form.querySelector('#registration-form-password');
  const passwordFieldConfirm = form.querySelector(
    '#registration-form-password-confirm'
  );
  if (passwordField.value !== passwordFieldConfirm.value) {
    const errorMessage = passwordFieldConfirm.getAttribute(
      'data-repeat-mismatch-error'
    );
    const errorField = form.querySelector('#form-password-confirm-error');
    errorField.innerText = errorMessage;

    isValid = false;
  }

  return isValid;
}

function submitRegister($form) {
  const url = $form.attr('action');
  $form.trigger('login:register');
  $.ajax({
    url,
    type: 'post',
    dataType: 'json',
    data: $form.serialize(),
    success(data) {
      if (!data.success) {
        $form.trigger('login:register:error', data);
        formValidation($form, data);
      } else {
        $form.trigger('login:register:success', data);
        if (data.isRgpdEmail === true) {
          // Send info for Analytics
          analyticsEventBus.publish(
            analyticsEventBus.EVENTS.newsletterSubscribed,
            analyticsEventBus.EVENTS.PAYLOADS.newsletterSubscribed.location
              .register
          );
        }
        // Send info for Analytics
        let location =
          analyticsEventBus.EVENTS.PAYLOADS.accountRegistered.location.account;
        if (data.queryString === 'rurl=2') {
          location =
            analyticsEventBus.EVENTS.PAYLOADS.accountRegistered.location
              .checkout;
        }
        analyticsEventBus.publish(
          analyticsEventBus.EVENTS.accountRegistered,
          location
        );
        // Redirect
        const redirectUrl = isVentaPrivada()
          ? ventaPrivadaRedirect()
          : data.redirectUrl;
        window.location.href = redirectUrl;
      }
    },
    error(err) {
      if (err.responseJSON.redirectUrl) {
        window.location.href = err.responseJSON.redirectUrl;
      } else {
        createErrorNotification(
          $('.error-messaging'),
          err.responseJSON.errorMessage
        );
      }
    },
  });
}

function checksRegisterBeforeSubmit(e) {
  const $form = $(e.target);
  const form = $form[0]; // jq to element
  e.preventDefault();

  const isFormatValid = clientSideValidation.functions.validateFormatData(form);
  if (isFormatValid) {
    const isBusinessValid = validateRegisterBusinessData(form);

    if (isBusinessValid) {
      submitRegister($form);
    }
  }
}

function validateResetPasswordBusinessData() {
  // Form business logic validation
  return true;
}

function submitResetPassword($form) {
  const url = $form.attr('action');
  const isCheckoutLoginPage =
    window.location.pathname === FRONT_CONFIG.urls.checkout;
  $form.trigger('login:register');
  const submitButton = $form.find('button[type="submit"]')[0];
  loader.addLoader(submitButton);
  $.ajax({
    url,
    type: 'post',
    dataType: 'json',
    data: $form.serialize(),
    success(data) {
      if (!data.success) {
        formValidation($form, data);
        loader.removeLoader(submitButton);
      } else {
        const button = document.querySelector(
          '.reset-password__submit.interaction--swap-text'
        );
        $('body').trigger('interaction--swap-text-event', button);
        setTimeout(() => {
          changePasswordModalText(data, !isCheckoutLoginPage);
          loader.removeLoader(submitButton);
        }, 1000);
        // Send info for Analytics
        analyticsEventBus.publish(
          analyticsEventBus.EVENTS.loginForgotPasswordSent
        );
      }
    },
  });
}

function checksResetPasswordBeforeSubmit(e) {
  const $form = $(e.target);
  const form = $form[0]; // jq to element

  e.preventDefault(); // to avoid redirect

  const isFormatValid = clientSideValidation.functions.validateFormatData(form);
  if (isFormatValid) {
    const isBusinessValid = validateResetPasswordBusinessData(form);

    if (isBusinessValid) {
      submitResetPassword($form);
    }
  }
}

// newPasswordForm.isml
// TODO: consider make this validation a more generic tool / helper. See other funcions on this file
function checksChangePasswordBeforeSubmit(e) {
  const $form = $(e.target);
  const form = $form[0]; // jq to element
  e.preventDefault();

  const isFormatValid = clientSideValidation.functions.validateFormatData(form);
  if (isFormatValid) {
    const isBusinessValid = validateChangePasswordBusinessData(form);

    if (isBusinessValid) {
      submitChangePassword($form);
    }
  }
}

// newPasswordForm.isml
function validateChangePasswordBusinessData(form) {
  // Form business logic validation
  let isValid = true;

  // both passwords are equal validation
  const passwordField = form.querySelector('#newPassword');
  const passwordFieldConfirm = form.querySelector('#newPasswordConfirm');
  if (passwordField.value !== passwordFieldConfirm.value) {
    const errorMessage = passwordFieldConfirm.getAttribute(
      'data-repeat-mismatch-error'
    );
    const errorField = form.querySelector('#form-password-confirm-error');
    errorField.innerText = errorMessage;

    isValid = false;
  }

  return isValid;
}

// newPasswordForm.isml
function submitChangePassword($form) {
  const url = $form.attr('action');
  const submitButton = document.querySelector('.account-form__submit');
  loader.addLoader(submitButton);
  $form.trigger('password:edit');
  $.ajax({
    url,
    type: 'post',
    dataType: 'json',
    data: $form.serialize(),
    success(data) {
      loader.removeLoader(submitButton);
      if (!data.success) {
        formValidation($form, data);
      } else {
        window.location.href = data.redirectUrl;
      }
    },
    error(err) {
      if (err.responseJSON?.redirectUrl) {
        window.location.href = err.responseJSON.redirectUrl;
      } else {
        loader.removeLoader(submitButton);
        createErrorNotification(
          $('.error-messaging'),
          err.responseJSON.errorMessage
        );
      }
    },
  });

  return false;
}

module.exports = {
  listenLoginSubmit() {
    $('body').on('submit', 'form.login', checksLoginBeforeSubmit);
  },
  login() {
    // moved to listenLoginSubmit
  },
  listenRegisterSubmit() {
    $('body').on('submit', 'form.registration', checksRegisterBeforeSubmit);
  },
  register() {
    // moved to listenRegisterSubmit
  },
  listenResetPasswordSubmit() {
    $('body').on(
      'submit',
      'form.reset-password',
      checksResetPasswordBeforeSubmit
    );
  },
  listenChangePasswordSubmit() {
    $('body').on(
      'submit',
      'form.change-password-form',
      checksChangePasswordBeforeSubmit
    );
  },
  resetPassword() {
    toggleLoginSubmit();
    const closeBtn = document.querySelector(
      '.request-password-reset-modal .btn-close'
    );
    // No remove event needed. This event is listened during whole visit
    // eslint-disable-next-line listeners/no-missing-remove-event-listener
    closeBtn?.addEventListener('click', toggleLoginSubmit);
    // moved to listenResetPasswordSubmit
  },
  clearResetForm: base.clearResetForm,
  navLinks() {
    $('.nav-link').on('click', (e) => {
      e.preventDefault();
      const tabId = $(this).attr('href');
      $('.tab-pane').removeClass('active');
      $(tabId).addClass('active');
    });
  },
  init() {
    $(() => {
      require('../components/ds/forms/document-type-selector').init();
    });
  },
};
